import React from 'react';
import { Layout, Menu, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useModalStore } from '@/store/useModalStore';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';

const { Header } = Layout;

export interface AixueHeaderProps {
  title?: string;
}

export default function AixueHeader({ title = 'Aixue' }: AixueHeaderProps) {
  const { openModalMask } = useModalStore();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname || '';
  const selectedKey = (() => {
    if (pathname.startsWith('/aixue-phonics') || pathname.startsWith('/aixue-ai'))
      return 'products';
    if (pathname.startsWith('/aixue-about')) return 'about';
    if (pathname.startsWith('/aixue-join')) return 'careers';
    if (pathname.startsWith('/aixue-downloads')) return 'downloads';
    return 'home';
  })();
  const isHome = pathname.startsWith('/aixue-') ? false : true;
  const productsItems = [
    {
      key: 'products-phonics',
      label: (
        <span className="aixue-menu-link" onClick={() => navigate('/aixue-phonics')}>
          爱学AI自然拼读
        </span>
      ),
    },
    {
      key: 'products-ai',
      label: (
        <span className="aixue-menu-link" onClick={() => navigate('/aixue-ai')}>
          爱学AI一对一导师
        </span>
      ),
    },
  ];
  const menuItems: MenuProps['items'] = [
    {
      key: 'home',
      label: (
        <Link
          className={`aixue-menu-link ${isHome ? 'animate__animated animate__bounceIn' : ''}`}
          style={{
            ...(isHome
              ? ({ animationDelay: '0.2s', animationDuration: '0.6s' } as React.CSSProperties)
              : {}),
          }}
          to="/"
        >
          首页
        </Link>
      ),
    },
    {
      key: 'products',
      label: (
        <Dropdown
          trigger={["hover"]}
          menu={{ items: productsItems }}
          overlayClassName="aixue-menu-overlay"
          placement="bottom"
          mouseLeaveDelay={0.4}
          arrow={true}
        >
          <span className={`aixue-menu-link ${isHome ? 'animate__animated animate__bounceIn' : ''}`}>产品中心</span>
        </Dropdown>
      ),
    },
    {
      key: 'about',
      label: (
        <Link
          className={`aixue-menu-link ${isHome ? 'animate__animated animate__bounceIn' : ''}`}
          style={{
            ...(isHome
              ? ({ animationDelay: '0.4s', animationDuration: '0.6s' } as React.CSSProperties)
              : {}),
          }}
          to="/aixue-about"
        >
          关于我们
        </Link>
      ),
    },
    {
      key: 'careers',
      label: (
        <Link
          className={`aixue-menu-link ${isHome ? 'animate__animated animate__bounceIn' : ''}`}
          style={{
            ...(isHome
              ? ({ animationDelay: '0.5s', animationDuration: '0.6s' } as React.CSSProperties)
              : {}),
          }}
          to="/aixue-join"
        >
          加入我们
        </Link>
      ),
    },
    {
      key: 'downloads',
      label: (
        <span
          className={`aixue-menu-link ${isHome ? 'animate__animated animate__bounceIn' : ''}`}
          style={{
            ...(isHome
              ? ({ animationDelay: '0.6s', animationDuration: '0.6s' } as React.CSSProperties)
              : {}),
          }}
          onClick={() => openModalMask('download-center')}
        >
          下载中心
        </span>
      ),
    },
  ];

  return (
    <Header className={styles.header}>
        <div className={styles.inner}>
          <div className={styles.logo}></div>
          <Menu
            className={styles.menu}
            mode="horizontal"
            theme="dark"
            triggerSubMenuAction="hover"
            selectedKeys={selectedKey ? [selectedKey] : []}
            items={menuItems}
          />
        </div>
    </Header>
  );
}
